module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAUBJREFUeNpi/D+f4QwDA4MiAwScAmJPINYG4tNAzMRAGLxjARIaQMwNFVADYpDYQyD2I8IAdpBFLGi2wdisQCwLxIwEDDkHxBdAhhxG8g7Ia3+AWAKIW4jwzgyQIYz///9nYFjAyA4V/InkIlYivPMXZCkLmmYY+IdFDCdgAboiFUhLQ/m3gHgZEEsCcSERYQIC3xiBUQyykQ0q8AiIFYBYGYjXEBEmIPlPIO98RTLkOzQs7gKxKRGu+M0ATROsKN6DSKgD8X6oTf9xGADy6jQgbgRpCgdicajEA6im1yBJIlxyEWwaNIoZKAGg2OEH0lxQ/mcg/gL1ogiRsfMPlmLlkVKsMzRMzhCZAd+zQJM8D1RAHuqKe0DsQGQGZMGWAUEBywHExkR4B1R0nGKBOlsHKVf+gabgfiK80wcyBCDAAAupQa02W+H3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/auth/overview.png
// module id = 932
// module chunks = 440